var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: "小票配置",
          backUrl: "/operation/printing/printreceipt",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "ivu-mt mt14",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "40px 50px" },
          },
        },
        [
          _c(
            "div",
            { staticClass: "acea-row row-between warpper" },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.formItem, "label-width": "120px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "小票头部：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.smallTickerHeader,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "smallTickerHeader", $$v)
                            },
                            expression: "formItem.smallTickerHeader",
                          },
                        },
                        [_vm._v("商家名称")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "配送信息：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.deliveryInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "deliveryInfo", $$v)
                            },
                            expression: "formItem.deliveryInfo",
                          },
                        },
                        [_vm._v("配送信息")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "买家备注：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.buyerRemark,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "buyerRemark", $$v)
                            },
                            expression: "formItem.buyerRemark",
                          },
                        },
                        [_vm._v("买家备注")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品信息：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.productInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "productInfo", $$v)
                            },
                            expression: "formItem.productInfo",
                          },
                        },
                        [_vm._v("商品基础信息")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "运费信息：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.freightInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "freightInfo", $$v)
                            },
                            expression: "formItem.freightInfo",
                          },
                        },
                        [_vm._v("运费")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优惠信息：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.discountInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "discountInfo", $$v)
                            },
                            expression: "formItem.discountInfo",
                          },
                        },
                        [_vm._v("优惠总计")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付信息：" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.formItem.payInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "payInfo", $$v)
                            },
                            expression: "formItem.payInfo",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: 1 } }, [
                            _vm._v("支付方式"),
                          ]),
                          _c("el-checkbox", { attrs: { label: 2 } }, [
                            _vm._v("实收金额"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "其他订单信息：" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.formItem.orderInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "orderInfo", $$v)
                            },
                            expression: "formItem.orderInfo",
                          },
                        },
                        [
                          _c("el-checkbox", { attrs: { label: 1 } }, [
                            _vm._v("订单编号"),
                          ]),
                          _c("el-checkbox", { attrs: { label: 2 } }, [
                            _vm._v("下单时间"),
                          ]),
                          _c("el-checkbox", { attrs: { label: 3 } }, [
                            _vm._v("支付时间"),
                          ]),
                          _c("el-checkbox", { attrs: { label: 4 } }, [
                            _vm._v("打印时间"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推广二维码：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.codeUrlSwitch,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "codeUrlSwitch", $$v)
                            },
                            expression: "formItem.codeUrlSwitch",
                          },
                        },
                        [_vm._v("选择系统链接")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.codeUrlSwitch === 1,
                              expression: "formItem.codeUrlSwitch === 1",
                            },
                          ],
                          staticClass: "link",
                        },
                        [
                          _c("div", { staticClass: "select-link" }, [
                            _vm._v(
                              " 链接：" + _vm._s(_vm.formItem.codeUrl) + " "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "change",
                                on: { click: _vm.getLink },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.formItem.codeUrl ? "修改" : "选择")
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "底部公告：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.formItem.bottomNoticeSwitch,
                            callback: function ($$v) {
                              _vm.$set(_vm.formItem, "bottomNoticeSwitch", $$v)
                            },
                            expression: "formItem.bottomNoticeSwitch",
                          },
                        },
                        [_vm._v("底部公告")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.bottomNoticeSwitch === 1,
                              expression: "formItem.bottomNoticeSwitch === 1",
                            },
                          ],
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "500px" },
                            attrs: {
                              maxlength: "50",
                              "show-word-limit": "",
                              type: "textarea",
                              placeholder: "请输入公告内容",
                            },
                            model: {
                              value: _vm.formItem.bottomNotice,
                              callback: function ($$v) {
                                _vm.$set(_vm.formItem, "bottomNotice", $$v)
                              },
                              expression: "formItem.bottomNotice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "ticket-preview" }, [
                _c("div", { staticClass: "out-line" }),
                _c("div", { staticClass: "ticket-content" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.smallTickerHeader === 1,
                          expression: "formItem.smallTickerHeader === 1",
                        },
                      ],
                      staticClass: "ticket-header",
                    },
                    [_vm._v("商家名称")]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.deliveryInfo == 1,
                          expression: "formItem.deliveryInfo == 1",
                        },
                      ],
                      staticClass: "delivery btn-line",
                    },
                    [
                      _c("div", { staticClass: "form-box" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("配送方式："),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v("商家配送"),
                        ]),
                      ]),
                      _c("div", { staticClass: "form-box" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("客户姓名："),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v("收货人姓名"),
                        ]),
                      ]),
                      _c("div", { staticClass: "form-box" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("客户电话："),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v("13023354455"),
                        ]),
                      ]),
                      _c("div", { staticClass: "form-box" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("收货地址："),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v("上海市浦东新区世界大道25号B座309室"),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.buyerRemark == 1,
                          expression: "formItem.buyerRemark == 1",
                        },
                      ],
                      staticClass: "buyer-remarks btn-line",
                    },
                    [
                      _c("div", { staticClass: "form-box" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("买家备注："),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v("请在收货时向商家留言，谢谢！"),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.productInfo === 1,
                          expression: "formItem.productInfo === 1",
                        },
                      ],
                    },
                    [
                      _c("div", { staticClass: "goods btn-line" }, [
                        _c("div", { staticClass: "star-line" }, [
                          _vm._v("商品"),
                        ]),
                        _c("div", { staticClass: "flex justify-between" }, [
                          _c("span", [_vm._v("商品")]),
                          _c("span", [_vm._v("单价")]),
                          _c("span", [_vm._v("数量")]),
                          _c("span", [_vm._v("金额")]),
                        ]),
                      ]),
                      _c("div", { staticClass: "goods-msg btn-line" }, [
                        _c("div", { staticClass: "flex justify-between" }, [
                          _c("span", [_vm._v("商品1")]),
                          _c("span", [_vm._v("100.0")]),
                          _c("span", [_vm._v("2")]),
                          _c("span", [_vm._v("200.0")]),
                        ]),
                        _c("div", { staticClass: "flex justify-between" }, [
                          _c("span", [_vm._v("(规格1)")]),
                          _c("span"),
                          _c("span"),
                          _c("span"),
                        ]),
                      ]),
                      _c("div", { staticClass: "goods-msg pb-10 pt-10" }, [
                        _c("div", { staticClass: "flex justify-between" }, [
                          _c("span", [_vm._v("商品2")]),
                          _c("span", [_vm._v("100.0")]),
                          _c("span", [_vm._v("2")]),
                          _c("span", [_vm._v("200.0")]),
                        ]),
                        _c("div", { staticClass: "flex justify-between" }, [
                          _c("span", [_vm._v("(规格2)")]),
                          _c("span"),
                          _c("span"),
                          _c("span"),
                        ]),
                      ]),
                      _c("div", { staticClass: "star-line" }, [
                        _vm._v("********"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "pay flex flex-col align-end btn-line" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.freightInfo == 1,
                              expression: "formItem.freightInfo == 1",
                            },
                          ],
                        },
                        [_vm._v("运费：10.00元")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.discountInfo == 1,
                              expression: "formItem.discountInfo == 1",
                            },
                          ],
                        },
                        [
                          _c("div", [_vm._v("优惠：-80.00元")]),
                          _c("div", [_vm._v("抵扣：-20.00元")]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.payInfo.length > 0,
                          expression: "formItem.payInfo.length > 0",
                        },
                      ],
                      staticClass: "pay flex flex-col align-end btn-line",
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.payInfo.includes(1),
                              expression: "formItem.payInfo.includes(1)",
                            },
                          ],
                        },
                        [_vm._v("支付方式：微信支付")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.payInfo.includes(2),
                              expression: "formItem.payInfo.includes(2)",
                            },
                          ],
                          staticClass: "fw-500",
                        },
                        [_vm._v("实际支付：310.00元")]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.orderInfo.length > 0,
                          expression: "formItem.orderInfo.length > 0",
                        },
                      ],
                      staticClass: "order pt-10 btn-line",
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.orderInfo.includes(1),
                              expression: "formItem.orderInfo.includes(1)",
                            },
                          ],
                        },
                        [_vm._v("订单编号：wx1234567890")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.orderInfo.includes(2),
                              expression: "formItem.orderInfo.includes(2)",
                            },
                          ],
                        },
                        [_vm._v("下单时间：2022/06/18 12:00:00")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.orderInfo.includes(3),
                              expression: "formItem.orderInfo.includes(3)",
                            },
                          ],
                        },
                        [_vm._v("支付时间：2022/06/18 12:00:00")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.formItem.orderInfo.includes(4),
                              expression: "formItem.orderInfo.includes(4)",
                            },
                          ],
                        },
                        [_vm._v("打印时间：2022/06/18 14:20:00")]
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "code" }, [
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formItem.codeUrlSwitch === 1,
                          expression: "formItem.codeUrlSwitch === 1",
                        },
                      ],
                      attrs: { id: "qrcode" },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.formItem.bottomNoticeSwitch === 1,
                            expression: "formItem.bottomNoticeSwitch === 1",
                          },
                        ],
                        staticClass: "mt20",
                      },
                      [_vm._v(" " + _vm._s(_vm.formItem.bottomNotice) + " ")]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "bottom-notice" }, [
                  _c("img", {
                    staticClass: "image",
                    attrs: { src: require("@/assets/imgs/p-btn.png"), alt: "" },
                  }),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "fixed-card",
          style: {
            left:
              "" +
              (_vm.collapseShow && !_vm.sideBar1
                ? "78px"
                : _vm.collapseShow && _vm.sideBar1
                ? "54px"
                : "130px"),
          },
          attrs: { bordered: false, "dis-hover": "" },
        },
        [
          _c(
            "el-button",
            {
              staticClass: "submission",
              attrs: { type: "primary" },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _c("linkaddress", {
        ref: "linkaddres",
        attrs: { isHotSpot: true, fromType: "printreceipt" },
        on: { linkUrl: _vm.linkUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }